<form class="example-form">
	<input [id]="id" type="text"
		#input="matAutocompleteTrigger"
		[ngClass]="inputClass"
		[formControl]="filterInput"
		[matAutocomplete]="dropdownlist"
		[matAutocompletePosition]="'below'"
		[attr.disabled]="disabled ? true : null"
		(focus)="onInputFocus()"
		(blur)="onInputBlur()"
		(click)="onInputClick()"
		(keyup)="onInputKeyUp($event)"
		/>
	<mat-autocomplete 
		#dropdownlist="matAutocomplete"
		[displayWith]="getLabel"
		(optionSelected)="onOptionSelected($event)"
		panelWidth="auto" 
		>
		
		<mat-option
			*ngFor="let item of filteredItems$ | async"
			[class]="'option'"
			[value]="item"
			>

			{{ getLabel(item) }}
		</mat-option>
	</mat-autocomplete>
</form>